import { createContext, useContext, useEffect, useState } from 'react';
import api from '../lib/api';

const AuthContext = createContext(null);
export const useAuth = () => useContext(AuthContext);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [authOpen, setAuthOpen] = useState(false);
  const [tgBindOpen, setTgBindOpen] = useState(false);

  useEffect(() => {
    api.get('/auth/me')
      .then((r) => setUser(r.data))
      .catch(() => api.post('/auth/refresh').then((r) => setUser(r.data)).catch(() => setUser(false)));
  }, []);

  useEffect(() => {
    const open = () => setTgBindOpen(true);
    window.addEventListener('telegram-bind-required', open);
    return () => window.removeEventListener('telegram-bind-required', open);
  }, []);

  const login = async (email, password) => {
    const { data } = await api.post('/auth/login', { email, password });
    setUser(data);
    return data;
  };

  const register = async (payload) => {
    const { data } = await api.post('/auth/register', payload);
    setUser(data);
    return data;
  };

  const logout = async () => {
    try { await api.post('/auth/logout'); } catch {}
    setUser(false);
  };

  const setPoints = (points) => setUser((u) => (u ? { ...u, points } : u));
  const updateUser = (data) => setUser((u) => (u && typeof u === 'object' ? { ...u, ...data } : data));

  return (
    <AuthContext.Provider value={{
      user, login, register, logout, setPoints, updateUser,
      authOpen, openAuth: () => setAuthOpen(true), closeAuth: () => setAuthOpen(false),
      tgBindOpen, openTelegramBind: () => setTgBindOpen(true), closeTelegramBind: () => setTgBindOpen(false),
    }}>
      {children}
    </AuthContext.Provider>
  );
};
